// @flow
import * as React from "react";
import type {Product} from "../../../models/Product";
import {determineDistributionChannelForPriceDisplay} from "../../../models/Product";
import "./NscDealerSearch.scss";
import {currencyConverter} from "../../../helper/currency";
import {DISTRIBUTION} from "../../../models/DistributionChannels";
import {emitInternalEvent, toProductDetails} from "../../../helper/tracker/internalEvents";

type Props = {
    product: Product,
    availableOnOtherDealersCount: number,
    showDealerList: boolean,
    setDealerList: boolean => void,
    t: string => string,
    showPrices: boolean,
    disclaimer: string,
    brand: string,
};

export const NscDealerSearch = (props: Props) => {
    let selectedOption = DISTRIBUTION.NONE;
    if (props.product.distributionChannels.mounting) {
        selectedOption = DISTRIBUTION.MOUNTING;
    }
    if (props.product.distributionChannels.pickup) {
        selectedOption = DISTRIBUTION.PICKUP;
    }

    const isMounting = selectedOption === DISTRIBUTION.MOUNTING;

    const renderPrice = (props: Props) => {
        const {unitPrice} = props.product;

        const {product} = props;
        const distChannel = determineDistributionChannelForPriceDisplay(product);
        const price = distChannel ? distChannel.price : product.price;
        const recommendedRetailPrice = distChannel ? distChannel.recommendedRetailPrice : product.recommendedRetailPrice;

        return <div className="hpm-nscPriceBox">
            <div className="hpm-price">
                {price ?
                    <>
                        <span className={"hpm-info"}>{props.t("productDetailNSC.price")} </span>
                        <span className={"hpm-price"}>{currencyConverter(price)}</span>
                        {unitPrice && <span className={"hpm-unitPrice"}>
                            <small>({currencyConverter(unitPrice.pricePerUnit)} / {unitPrice.measuringUnit})</small>
                            </span>
                        }
                    </>
                    : <span className={"hpm-price"}>{props.t("productDetail.priceOnRequest")}</span>
                }
            </div>
            <div>
                {price &&
                    <span className={"hpm-info"}>
                        {props.t("productDetail.inclVAT")}
                        {isMounting && <React.Fragment> {props.t("productDetail.and")} {props.t("productDetail.inclMount")}</React.Fragment>}
                    </span>
                }
            </div>
            {recommendedRetailPrice && <div className={"hpm-retailPrice"}>
                    <span className={"hpm-info"}>{props.t("productDetailNSC.originalRRP")}</span>
                    <span className={"hpm-info"}>{currencyConverter(recommendedRetailPrice)} </span>
                </div>
            }
        </div>;
    };

    return !!props.availableOnOtherDealersCount && <div className={"NscDealerSearch"}>
        {props.showPrices && renderPrice(props)}
        <div className="hpm-dealerCount">
            <span>{props.t("nsc.availableGarages", {count: props.availableOnOtherDealersCount, brand: props.brand})}</span>
        </div>
        <div className="hpm-actions">
            <button type={"button"} className={"hpm-cartButton"} onClick={() => {
                emitInternalEvent("central_find_dealer", {product: toProductDetails(props.product)});
                props.setDealerList(true);
            }}>
                {props.t("nsc.cartButton", {brand: props.brand})}
            </button>
        </div>
        {props.showPrices &&
            <div className="hpm-priceDisclaimer" dangerouslySetInnerHTML={{__html: props.disclaimer}}/>}
    </div>;
};
